"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[995],{

/***/ 90182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ FOOTER_NAV_SOCIAL; },
/* harmony export */   "h2": function() { return /* binding */ FOOTER_NAV_GROUPS; },
/* harmony export */   "vN": function() { return /* binding */ FOOTER_NAV_SECONDARY; }
/* harmony export */ });
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97143);
/* harmony import */ var features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82324);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62177);
/* harmony import */ var utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55920);
/* harmony import */ var utils_localize_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38062);





var FOOTER_NAV_GROUPS = function(t, locale) {
    return [
        {
            title: t("nav.talentTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.talent */ .uu.talent, locale)),
                    title: t("nav.product")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.manfredDaily */ .uu.manfredDaily, locale)),
                    title: t("nav.telegramOffers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.jobOffers */ .uu.jobOffers, locale), "?").concat((0,utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_2__/* .getUrlParamsFromJobOffersFilter */ .Ci)(features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_FILTER */ .XW, (0,utils_localize_utils__WEBPACK_IMPORTED_MODULE_3__/* .getLocale */ .K)(locale))),
                    title: t("nav.offers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.salaryCompass */ .uu.salaryCompass, locale)),
                    title: t("nav.salaryCompass")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.roles */ .uu.roles, locale)),
                    title: t("nav.roles")
                }
            ]
        },
        {
            title: t("nav.companiesTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.companies */ .uu.companies, locale)),
                    title: t("nav.services")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.yourOfferSalary */ .uu.yourOfferSalary, locale)),
                    title: t("nav.yourOfferSalary")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.hrAsAService */ .uu.hrAsAService, locale)),
                    title: t("nav.hr-as-a-service")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.manfredDailyCompanies */ .uu.manfredDailyCompanies, locale)),
                    title: t("nav.daily")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.outOfOffice */ .uu.outOfOffice, locale)),
                    title: t("nav.outOfOffice")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.helpingCompanies */ .uu.helpingCompanies, locale)),
                    title: t("nav.helpingCompanies")
                }
            ]
        },
        {
            title: t("nav.knowledgeTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.blog */ .uu.blog, locale)),
                    title: t("nav.blog")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.mantechcar24 */ .uu.mantechcar24, locale)),
                    title: t("nav.stateOfTheSector")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.hiringProcessComparison */ .uu.hiringProcessComparison, locale)),
                    title: t("nav.hiringProcessComparison")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.helpingJuniors */ .uu.helpingJuniors, locale)),
                    title: t("nav.helpingJuniors")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.stateOfHiring */ .uu.stateOfHiring, locale)),
                    title: t("nav.hiringReport")
                }
            ]
        },
        {
            title: t("nav.manfredTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.team */ .uu.team, locale)),
                    title: t("nav.us")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.blog */ .uu.blog, locale), "/compromiso-etico-manfred"),
                    title: t("nav.ethicalCommitment")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.battleReport */ .uu.battleReport, locale)),
                    title: t("nav.battleReport")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.joinUs */ .uu.joinUs, locale)),
                    title: t("nav.joinUs")
                }
            ]
        }
    ];
};
var FOOTER_NAV_SECONDARY = function(t, locale) {
    return [
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.termsOfUse */ .uu.termsOfUse, locale)),
            title: t("nav.terms")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.privacyPolicy */ .uu.privacyPolicy, locale)),
            title: t("nav.privacy")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_1__/* .APP_URLS.cookies */ .uu.cookies, locale)),
            title: t("nav.cookies")
        }
    ];
};
var FOOTER_NAV_SOCIAL = function() {
    return [
        {
            title: "Twitter",
            href: "https://twitter.com/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTwitter */ .mdU
        },
        {
            title: "Twitch",
            href: "https://www.twitch.tv/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTwitch */ .z0T
        },
        {
            title: "LinkedIn",
            href: "https://es.linkedin.com/company/manfred/",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faLinkedin */ .D9H
        },
        {
            title: "GitHub",
            href: "https://github.com/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faGithub */ .zhw
        },
        {
            title: "Telegram",
            href: "https://t.me/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTelegramPlane */ .IKq
        }
    ];
};


/***/ }),

/***/ 59072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ StyledNavGroup; },
/* harmony export */   "Dr": function() { return /* binding */ StyledFooterMain; },
/* harmony export */   "GS": function() { return /* binding */ StyledFooterLogoLang; },
/* harmony export */   "Gr": function() { return /* binding */ StyledFooterContainer; },
/* harmony export */   "LX": function() { return /* binding */ StyledFooterSecondary; },
/* harmony export */   "Oo": function() { return /* binding */ StyledFooterCopyright; },
/* harmony export */   "Re": function() { return /* binding */ StyledFooterNavItem; },
/* harmony export */   "Tu": function() { return /* binding */ StyledNavGroupTitle; },
/* harmony export */   "jO": function() { return /* binding */ StyledFooterNavCopy; },
/* harmony export */   "tc": function() { return /* binding */ StyledFooter; },
/* harmony export */   "xp": function() { return /* binding */ StyledFooterNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23211);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);
/* harmony import */ var _topbar_TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21058);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  color: ",
        ";\n\n  &.not-scrollTop {\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  img {\n    display: block;\n    width: auto;\n    height: ",
        ";\n  }\n\n  ",
        " button {\n    margin: 0;\n    padding: 0;\n    color: ",
        ";\n    min-height: auto;\n\n    &:hover {\n      color: inherit;\n      background-color: transparent;\n    }\n\n    &::after {\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    }\n  }\n\n  ",
        " {\n    left: 0;\n    right: unset;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-end;\n    margin-left: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: 11rem;\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active,\n  &.active {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  ul {\n    display: flex;\n    gap: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:active,\n    &.active {\n      color: ",
        ";\n    }\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].footer.withConfig */ .ZP.footer.withConfig({
    componentId: "sc-a503a5bd-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_900"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default_inverse"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl3"));
var StyledFooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("xlMax"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFooterMain = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("lg"));
var StyledFooterLogoLang = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), _topbar_TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledLanguage */ .j, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default_inverse"), components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledDropdown */ .EI, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default"));
var StyledFooterCopyright = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].small.withConfig */ .ZP.small.withConfig({
    componentId: "sc-a503a5bd-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle_inverse"));
var StyledFooterNav = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].nav.withConfig */ .ZP.nav.withConfig({
    componentId: "sc-a503a5bd-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("lg"));
var StyledNavGroup = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-6"
})(_templateObject6(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"));
var StyledNavGroupTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-7"
})(_templateObject7(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"));
var StyledFooterNavItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-a503a5bd-8"
})(_templateObject8(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_hover"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_active"));
var StyledFooterNavCopy = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-9"
})(_templateObject9(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_800"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledFooterSecondary = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-10"
})(_templateObject10(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), StyledFooterNavItem, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_white"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_hover"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_active"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("mdlg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("mdlg"));


/***/ }),

/***/ 70995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _asgard_ui_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78197);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39105);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66582);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40286);
/* harmony import */ var utils_logos__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4335);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64516);
/* harmony import */ var _topbar_TopbarLanguage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74971);
/* harmony import */ var _Footer_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90182);
/* harmony import */ var _Footer_styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  body {\n    padding-bottom: ",
        ";\n  }\n\n  @media (max-height: ",
        ") {\n    body {\n      padding-bottom: 0 !important;\n    }\n    .main-footer {\n      position: static !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .createGlobalStyle */ .vJ)(_templateObject(), function(props) {
    return props.footerHeight ? props.footerHeight + "px !important" : "";
}, function(props) {
    return props.footerHeight + "px";
});
var Footer = function(param) {
    var offerFooter = param.offerFooter, hasScrollTop = param.hasScrollTop, isInCustomFooter = param.isInCustomFooter;
    var footerHeight = function footerHeight() {
        if (footerRef === null || footerRef === void 0 ? void 0 : footerRef.current) {
            setHeight(footerRef.current.clientHeight);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(0), height = ref[0], setHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), year = ref1[0], setYear = ref1[1];
    var footerRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_4__/* .useI18n */ .Q)("footer").t;
    var locale = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        footerHeight();
        var triggerEvent = react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isMobile */ .tq ? "orientationchange" : "resize";
        window.addEventListener(triggerEvent, footerHeight);
        return function() {
            window.removeEventListener(triggerEvent, footerHeight);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        setYear(new Date().getFullYear());
    }, []);
    var footerNav = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_GROUPS */ .h2)(t, locale);
    var footerNavSecondary = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_SECONDARY */ .vN)(t, locale);
    var footerNavSocial = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_SOCIAL */ .Rw)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GlobalStyle, {
                footerHeight: height
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooter */ .tc, {
                ref: isInCustomFooter ? undefined : footerRef,
                className: "".concat(isInCustomFooter ? "" : "main-footer", " ").concat(offerFooter && !hasScrollTop ? "not-scrollTop" : ""),
                children: [
                    offerFooter,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterContainer */ .Gr, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterMain */ .Dr, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterLogoLang */ .GS, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                loading: "lazy",
                                                src: utils_logos__WEBPACK_IMPORTED_MODULE_13__/* .LOGO_MANFRED_WHITE */ .YM,
                                                alt: "Manfred logo",
                                                width: "132",
                                                height: "24"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_topbar_TopbarLanguage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNav */ .xp, {
                                        "aria-label": t("nav.label"),
                                        children: footerNav.map(function(group, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledNavGroup */ .$H, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledNavGroupTitle */ .Tu, {
                                                        children: group.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                        children: group.navItems.map(function(navItem, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                                        href: navItem.href,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavItem */ .Re, {
                                                                            children: navItem.title
                                                                        })
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    group.action && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: group.action
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavCopy */ .jO, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterCopyright */ .Oo, {
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " ",
                                            t("nav.manfredTech")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterSecondary */ .LX, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                children: footerNavSecondary.map(function(navItem, index) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            href: navItem.href,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavItem */ .Re, {
                                                                children: navItem.title
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_asgard_ui_library__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                                                alignment: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        href: "/humans.txt",
                                                        target: "_blank",
                                                        rel: "noreferrer noopener",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                            loading: "lazy",
                                                            src: (0,utils_paths__WEBPACK_IMPORTED_MODULE_14__/* .getPublicPath */ .A)("/images/humanstxt.png"),
                                                            alt: "Humans.txt logo"
                                                        })
                                                    }),
                                                    footerNavSocial.map(function(navItem, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            title: navItem.title,
                                                            href: navItem.href,
                                                            target: "_blank",
                                                            rel: "noreferrer noopener",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                icon: navItem.icon
                                                            })
                                                        }, index);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ })

}]);